module.exports = __webpack_public_path__ + "static/media/example-demo.bd726df5.png";